module.exports = __webpack_public_path__ + "img/userIcon.e3523f0b.png";